import React, { useEffect, useState } from 'react'
import System from 'src/helper/system';
import { useCartStore } from 'src/hooks/cart';
import { profileStore } from 'src/hooks/profile';
import useReduxState from 'src/hooks/useReduxState';
import Constants from 'src/helper/Constants';
import Helper from 'src/helper/Helper';


const CheckoutInvoiceAddress = (props) => {
    const { orderValidation, setOrderValidation, setShowAlert, paymentMethod, isFrom = "" } = props
    const [{ CART_PRODUCTS, CART_DATA }, { }, { }] = useCartStore();
    const [shippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')
    const [paymentMethodInfo, setPaymentMethodInfo] = useReduxState({}, 'setPaymentMethodInfo')
    const [, setTnc] = useReduxState(false, 'setTnc');
    const isOnlySoftwareParts = CART_PRODUCTS && !Object.values(CART_PRODUCTS).some(f => f.SoftwareDownloadFlag === false);
    const { siteUser, addressType, paymentType: { AvnetCredit }, quote } = Constants
    const [checkoutData] = useReduxState({}, 'setCheckoutData')
    const [quoteHeaderData] = useReduxState({}, 'setQuoteHeaderData')
    const [addressData, setAddressData] = useState({ billToData: null, shipToData: null })

    const [{ profile_account_information }, { }] = profileStore();
    const isWebUser = System.avUserInfoData.currentUser === siteUser.WEB
    const isFromQuote = isFrom === quote ? true : false

    useEffect(() => {
        setAddressData({
            billToData: isFromQuote ? checkoutData?.soldToAddress : (profile_account_information?.billTo?.length ? profile_account_information?.billTo[0]?.address : null),
            shipToData: isFromQuote ? checkoutData?.shipToAddress : shippingAddressInfo?.address
        })
    }, [profile_account_information?.billTo, shippingAddressInfo?.address, checkoutData])

    useEffect(() => {
        setPaymentMethodInfo({
            ...paymentMethodInfo,
            invoiceAddressType: isOnlySoftwareParts ?
                (profile_account_information?.billTo?.length != 0 ? addressType.BILL_TO : paymentMethodInfo?.invoiceAddressType) :
                paymentMethodInfo?.invoiceAddressType
        })
    }, [CART_DATA, profile_account_information?.billTo])

    const openInvoicePopup = (addressInfo) => {
        System.popup('ProfileAddressPopup', addressInfo);
    }

    const renderAddress = (addressData, companyName) => {
        return <div className='font-arial font-13'>
            {companyName}
            <p className='font-arial font-13'>
                <div>{addressData?.addressLineOne && addressData?.addressLineOne + ","}</div>
                {Helper.valueIsNotNull(addressData?.addressLineTwo) && <div>{addressData?.addressLineTwo + ","}</div>}
                {Helper.valueIsNotNull(addressData?.cityName) ? addressData?.cityName + ", " : ""}
                {Helper.valueIsNotNull(addressData?.stateName) ? addressData?.stateName + ", " : ""}
                {addressData?.postalCode && addressData?.postalCode + ","}<br />
                {addressData?.countryName}
            </p>
        </div>;
    };

    const renderQuoteAddress = (addressData, companyName) => {
        return <div className='font-arial font-13'>
            {companyName}
            <p className='font-arial font-13'>
                <div>{addressData?.address1stLine && addressData?.address1stLine + ","}</div>
                {Helper.valueIsNotNull(addressData?.addressLineTwo) && <div>{addressData?.addressLineTwo + ","}</div>}
                {Helper.valueIsNotNull(addressData?.city) ? addressData?.city + ", " : ""}
                {Helper.valueIsNotNull(addressData?.stateName) ? addressData?.stateName + ", " : ""}
                {addressData?.zipCode && addressData?.zipCode + ","}<br />
                {addressData?.countryName}
            </p>
        </div>;
    };

    return (
        <div className='invoice-address-container'>
            <div className='bs5 row'>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 invoice-address-list'>
                    <h3 className="mt-0 mb-2">INVOICE ADDRESS:</h3>
                    {isOnlySoftwareParts ?
                        <>
                            <div className='choose-address-box'>
                                {profile_account_information?.billTo?.length <= 0 ?
                                    <button type="button" onClick={() => openInvoicePopup({
                                        'type': addressType.BILL_TO,
                                        'addressInfo': {}
                                    })} className="addnewaddress mt-2">
                                        <i className="fa fa-plus me-2" aria-hidden="true"></i>ADD AN INVOICE ADDRESS
                                    </button>
                                    : <div>
                                        <p className='mt-0 mb-2'><b>Current Invoice Address</b></p>
                                        {renderAddress(addressData.billToData, profile_account_information?.billTo?.[0]?.companyName)}
                                    </div>}
                            </div>
                        </> :
                        <>
                            {!isFromQuote && (isWebUser ? <p className='mt-0 mb-2'>Where do you want your invoice sent?</p> : <p className='mt-0 mb-2'><b>Current Invoice Address</b></p>)}

                            {addressData.billToData &&
                                <>
                                    {isWebUser && !isFromQuote && <div className="form-check mb-1">
                                        <input className="form-check-input mt-1" type="radio" name="invoiceAddress" id="radio1"
                                            value="currentInvoice"
                                            onChange={({ target: { value } }) => {
                                                setTnc(false)
                                                setShowAlert(false);
                                                setPaymentMethodInfo({ ...paymentMethodInfo, invoiceAddressType: addressType.BILL_TO })
                                            }} />
                                        <label className="form-check-label" htmlFor="radio1">Current Invoice Address</label>
                                    </div>}

                                    <div className='choose-address-box'>
                                        <div className='font-arial font-13'>
                                            {isFromQuote ?
                                                renderQuoteAddress(addressData.billToData, quoteHeaderData?.soldToCustomerName) :
                                                renderAddress(addressData.billToData, profile_account_information?.billTo?.[0]?.companyName)
                                            }
                                        </div>
                                    </div>

                                    {isWebUser && !isFromQuote && <p className="font-arial font-13 text-blue cursor-pointer"
                                        onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': addressData.billToData && profile_account_information?.billTo[0] })}>
                                        Edit
                                    </p>}
                                </>
                            }

                            {isWebUser && !isFromQuote &&
                                <>
                                    <div className="form-check mb-1">
                                        <input className="form-check-input mt-1" type="radio" name="invoiceAddress" id="radio2"
                                            value="defaultShipping"
                                            onChange={({ target: { value } }) => {
                                                setTnc(false)
                                                setShowAlert(false);
                                                setPaymentMethodInfo({ ...paymentMethodInfo, invoiceAddressType: addressType.SHIP_TO })
                                            }} />
                                        <label className="form-check-label" htmlFor="radio2">Use Shipping Address as Invoice Address</label>
                                    </div>

                                    {addressData.shipToData && <div className='choose-address-box'>
                                        <div className='font-arial font-13'>
                                            {renderAddress(addressData.shipToData, shippingAddressInfo?.companyName)}
                                        </div>
                                    </div>}

                                    {profile_account_information?.billTo?.length <= 0 && !isFromQuote &&
                                        <button type="button" onClick={() => openInvoicePopup({ 'type': addressType.BILL_TO, 'addressInfo': {} })} className="addnewaddress mt-2">
                                            <i className="fa fa-plus me-2" aria-hidden="true"></i>ADD AN INVOICE ADDRESS
                                        </button>}
                                </>}
                        </>}

                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 '>
                    <div className='form-group'>
                        <label className="form-label">Purchase Order Number ({paymentMethod === AvnetCredit ? "*" : "Optional"})</label>
                        <input type="text"
                            className={`form-control form-control-sm ${orderValidation?.purchaseOrderNumber ? "error" : ""}`}
                            placeholder="Purchase Order Number" name="purchaseOrderNumber"
                            maxLength={35}
                            onChange={({ target: { value } }) => {
                                setOrderValidation({})
                                setPaymentMethodInfo({ ...paymentMethodInfo, purchaseOrderNumber: value })
                            }} />
                        {orderValidation?.purchaseOrderNumber && <p className="error">{orderValidation?.purchaseOrderNumber}</p>}
                    </div>
                </div>
            </div>
            <hr className='p-0'></hr>
        </div>
    );
}

export default CheckoutInvoiceAddress;